export const UPDATE_TASKS = "UPDATE_TASKS"; // Update List of Taks
export const UPDATE_TASK = "UPDATE_TASK"; // Update Single Task
export const UPDATE_LAST_SEEN = "UPDATE_LAST_SEEN"; // Update Single Task
export const REFRESH_TASK = "REFRESH_TASK"; // Refresh Task
export const CLEAR_TASK = "CLEAR_TASK"; // Clear data

const initialState = {
  version: 1,
  lastFetchAt: new Date().setHours(0, 0, 0, 0), // Last data fetch at. initial = midnight millis
  lastSeenAt: null, //Notification Last Seen At by logged in user
  data: {} // key: id, value: ScheduledTask object
};

const scheduledTaskReducer = (state = initialState, { type, payload }) => {
  const { task = {}, taskList = [], lastFetchAt, lastSeenAt } = payload || {};
  if (type === UPDATE_TASKS) {
    return {
      ...state,
      data: {
        ...state.data,
        ...taskList.reduce((acc, task) => ({ ...acc, [task.id]: task }), {})
      },
      lastFetchAt: lastFetchAt || new Date().getTime()
    };
  } else if (type === UPDATE_TASK) {
    return {
      ...state,
      data: {
        ...state.data,
        [task.id]: task
      }
    };
  } else if (type === UPDATE_LAST_SEEN) {
    return { ...state, lastSeenAt };
  } else if (type === REFRESH_TASK) {
    return { ...state, version: state.version + 1 };
  } else if (type === CLEAR_TASK) {
    return initialState;
  } else {
    return state;
  }
};

export default scheduledTaskReducer;
